module.exports = __webpack_public_path__ + "static/media/video.aa5feb78.mp4";